import Modal from 'react-modal';

export function HelpModal(props: { isOpen: boolean, onClose: () => any }) {
    return <Modal
        isOpen={props.isOpen}
        onRequestClose={props.onClose}
        contentLabel="Modal"
        className="modal-dialog modal-dialog-centered"
        overlayClassName="react-modal-overlay"
    >
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title">ヘルプ</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={props.onClose}></button>
            </div>
            <div className="modal-body">
                <h6 className='is-style-orange-left-decoration has-large-font-size'>カードを追加するには？</h6>
                <p className='mb-0'>
                    カード一覧で、
                </p>
                <ul className='mb-0'>
                    <li>カードをクリックして「デッキに追加」を選択</li>
                    <li>カード画像をこの箇所にドラッグアンドドロップ</li>
                </ul>
                <p>
                    することにより追加できます。
                </p>
                <h6 className='is-style-orange-left-decoration has-large-font-size'>カードを変更するには？</h6>
                <p>
                    デッキのカードをタップ、またはマウスカーソルを近づけてください。
                </p>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-primary rounded-pill" onClick={props.onClose}>
                    閉じる
                </button>
            </div>
        </div>
    </Modal>
}